import { useEffect } from 'react'
import { Loader } from '@/components/ui/loader'
import { integrationsClient } from '@/lib/api/integrations/integrations.client'
import { INTEGRATIONS } from '@super/shared-types'
import type { VendorCatalogClick, VendorConnectorProps } from './types'

const ONBOARDING_RETURN_PATH = '/onboarding/integrations'

function launchInstallFlow(
  mode: 'onboarding' | 'settings',
  isSuperAdmin: boolean,
  currentCompanyId: string | null,
) {
  if (isSuperAdmin && currentCompanyId) {
    window.location.href =
      integrationsClient.hubspot.getAdminInstallUrl(currentCompanyId)
    return
  }
  const returnPath = mode === 'onboarding' ? ONBOARDING_RETURN_PATH : undefined
  window.location.href = integrationsClient.hubspot.getInstallUrl(returnPath)
}

/**
 * Catalog click: fire OAuth immediately. No sub-page detour.
 * Uses the super-admin variant when the caller is acting on another company's
 * behalf — matches what Settings was doing inline.
 */
export const hubspotCatalogClick: VendorCatalogClick = ({
  mode,
  isSuperAdmin,
  currentCompanyId,
}) => {
  launchInstallFlow(mode, isSuperAdmin, currentCompanyId)
}

/**
 * Sub-page: reached only via deep-link. Auto-launches OAuth so the behavior
 * matches the catalog-click path.
 */
export function HubspotConnector({ mode }: VendorConnectorProps) {
  useEffect(() => {
    // Sub-page mount doesn't have auth context here — the sub-page is a
    // deep-link fallback and always uses the non-admin flow. Admin users
    // land here only through the catalog, which calls hubspotCatalogClick
    // directly and doesn't render this sub-page.
    launchInstallFlow(mode, false, null)
  }, [mode])

  return (
    <div className="flex flex-col items-center gap-2 py-8 text-center">
      <Loader text={`Redirecting to ${INTEGRATIONS.HUBSPOT.NAME}…`} />
    </div>
  )
}
